import { Pipe, PipeTransform } from '@angular/core';
import { dollarsToCents } from "../../shared/utils";

@Pipe({
  name: 'dollarsToCents'
})

export class dollarsToCentsPipe implements PipeTransform {
  transform(value: any): any {
    return dollarsToCents(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/dollars-to-cents.pipe.ts